// removed by extract-text-webpack-plugin
module.exports = {"root":"Contact__root___3EpNH","title":"Contact__title___1mqQh"};


//////////////////
// WEBPACK FOOTER
// ./app/views/Contact/Contact.css
// module id = 107
// module chunks = 0